"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormConditionalNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'FORM-CONDITIONAL';
class FormConditionalNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            return params;
        };
        this._interfaceDefinition = Schema;
    }
    get interfaceDefinition() {
        return Object.assign(Object.assign({}, this._interfaceDefinition.definitions), { 
            //We override the output params for this node. Even though technically we could still hook up to it, it would likely confuse the user
            OutputParams: {} });
    }
}
exports.FormConditionalNode = FormConditionalNode;
FormConditionalNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Form Conditional',
    isIdempotent: true,
    primaryCategory: 'Object Creation',
};
//# sourceMappingURL=FormConditional.js.map